var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSportsbookAzIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon sportsbook-az-icon",
    viewBox: "0 0 31 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.337 0l5.762 15.566L25.407 3.35H17V0h13.765v2.225l-8.3 12.437H31V18H13.33l-1.052-3.363H5.685L4.645 18H0L6.614 0zm-2.35 4.235l-2.253 6.902h4.52L8.985 4.235z"
  })));
}

export default SvgSportsbookAzIconSv;